export default "__VITE_ASSET__BffPwODr__"